import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';

import SEO from '../components/SEO';

const PrivacyPolicy = () => {
    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc', py: 10 }}>
            <SEO
                title="Privacy Policy"
                description="Read our Privacy Policy to understand how we collect, use, and protect your personal information."
                canonical="https://10dstores.in/privacy-policy"
            />
            <Container maxWidth="md">
                <Paper sx={{ p: 5, borderRadius: 4 }}>
                    <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 4 }}>
                        Privacy Policy
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                        Last Updated: December 1, 2025
                    </Typography>

                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            1. Information We Collect
                        </Typography>
                        <Typography variant="body1" paragraph>
                            We collect information you provide directly to us, such as when you create or modify your account, request on-demand services, contact customer support, or otherwise communicate with us. This information may include: name, email, phone number, postal address, profile picture, payment method, and other information you choose to provide.
                        </Typography>
                    </Box>

                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            2. How We Use Your Information
                        </Typography>
                        <Typography variant="body1" paragraph>
                            We use the information we collect to provide, maintain, and improve our services, such as to:
                        </Typography>
                        <ul>
                            <li><Typography variant="body1">Process payments and facilitate delivery.</Typography></li>
                            <li><Typography variant="body1">Send you receipts and order updates.</Typography></li>
                            <li><Typography variant="body1">Provide customer support.</Typography></li>
                            <li><Typography variant="body1">Send you marketing communications (which you can opt out of).</Typography></li>
                        </ul>
                    </Box>

                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            3. Sharing of Information
                        </Typography>
                        <Typography variant="body1" paragraph>
                            We may share the information we collect about you as described in this Statement or as described at the time of collection or sharing, including with our store partners to fulfill your orders.
                        </Typography>
                    </Box>

                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            4. Data Security
                        </Typography>
                        <Typography variant="body1" paragraph>
                            We take reasonable measures to help protect information about you from loss, theft, misuse and unauthorized access, disclosure, alteration and destruction.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            5. Contact Us
                        </Typography>
                        <Typography variant="body1" paragraph>
                            If you have any questions about this Privacy Policy, please contact us at privacy@10dstores.in.
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default PrivacyPolicy;
